module.exports = __webpack_public_path__ + "img/hslogo3.600a5f09.png";